// src/input-event.ts
var getWindow = (el) => el.ownerDocument.defaultView || window;
function getDescriptor(el, options) {
  const { type = "HTMLInputElement", property = "value" } = options;
  const proto = getWindow(el)[type].prototype;
  return Object.getOwnPropertyDescriptor(proto, property) ?? {};
}
function setElementValue(el, value, option = {}) {
  const descriptor = getDescriptor(el, option);
  descriptor.set?.call(el, value);
}
function setElementChecked(el, checked) {
  const descriptor = getDescriptor(el, { type: "HTMLInputElement", property: "checked" });
  descriptor.set?.call(el, checked);
}
function dispatchInputValueEvent(el, options) {
  const { value, bubbles = true } = options;
  if (!el)
    return;
  const win = getWindow(el);
  if (!(el instanceof win.HTMLInputElement))
    return;
  setElementValue(el, `${value}`);
  el.dispatchEvent(new win.Event("input", { bubbles }));
}
function dispatchInputCheckedEvent(el, options) {
  const { checked, bubbles = true } = options;
  if (!el)
    return;
  const win = getWindow(el);
  if (!(el instanceof win.HTMLInputElement))
    return;
  setElementChecked(el, checked);
  el.dispatchEvent(new win.Event("click", { bubbles }));
  el.dispatchEvent(new win.Event("change", { bubbles }));
}

// src/form.ts
import { observeAttributes } from "@zag-js/mutation-observer";
function getClosestForm(el) {
  if (isFormElement(el))
    return el.form;
  else
    return el.closest("form");
}
function isFormElement(el) {
  return el.matches("textarea, input, select, button");
}
function trackFormReset(el, callback) {
  if (!el)
    return;
  const form = getClosestForm(el);
  form?.addEventListener("reset", callback, { passive: true });
  return () => {
    form?.removeEventListener("reset", callback);
  };
}
function trackFieldsetDisabled(el, callback) {
  const fieldset = el?.closest("fieldset");
  if (!fieldset)
    return;
  callback(fieldset.disabled);
  return observeAttributes(fieldset, ["disabled"], () => callback(fieldset.disabled));
}
function isNativeDisabled(el) {
  return el.matches(":disabled");
}
function trackFormControl(el, options) {
  if (!el)
    return;
  const { onFieldsetDisabledChange, onFormReset } = options;
  const cleanups = [trackFormReset(el, onFormReset), trackFieldsetDisabled(el, onFieldsetDisabledChange)];
  return () => {
    cleanups.forEach((cleanup) => cleanup?.());
  };
}
export {
  dispatchInputCheckedEvent,
  dispatchInputValueEvent,
  getClosestForm,
  isNativeDisabled,
  setElementChecked,
  setElementValue,
  trackFormControl
};
//# sourceMappingURL=index.mjs.map